export default __webpack_public_path__ + "static/media/gatewayar.bb17114f.png";